module.exports = __webpack_public_path__ + "img/e-cost.0a4ab79a.png";